import { createCollection, localOnlyCollectionOptions } from '@tanstack/db'

export interface Todo {
  id: string
  title: string
  completed: boolean
}

export const todosCollection = createCollection(
  localOnlyCollectionOptions<Todo>({
    getKey: (todo) => todo.id,
    initialData: [],
  }),
)
